import type { EffectDefinition } from "@/effects/types";

export const VIGNETTE_SHADER = "vignette";

function parseIntensity(effectParams: Record<string, unknown>): number {
	const raw = effectParams.intensity;
	return typeof raw === "number" ? raw : Number.parseFloat(String(raw));
}

/** intensity in [0, 100], 0 = no change, 100 = full corner darkening (matches vignette.wgsl,
 * which expects a [0, 1] amount). */
export function intensityToVignetteAmount(intensity: number): number {
	return intensity / 100;
}

export const vignetteEffectDefinition: EffectDefinition = {
	type: "vignette",
	name: "Виньетирование",
	keywords: ["vignette", "darken", "corners", "color"],
	params: [
		{
			key: "intensity",
			label: "Интенсивность",
			type: "number",
			default: 40,
			min: 0,
			max: 100,
			step: 1,
		},
	],
	renderer: {
		passes: [
			{
				shader: VIGNETTE_SHADER,
				uniforms: ({ effectParams }) => ({
					u_amount: intensityToVignetteAmount(parseIntensity(effectParams)),
				}),
			},
		],
	},
};
